/* eslint-disable react/display-name */
'use client';

import {useRouter} from 'next/navigation';
import {useTranslations} from 'next-intl';
import {type FC, lazy, memo, type ReactElement, Suspense, useRef} from 'react';
import {Button} from '@/shared/components/Button';
import AppImage from './AppImage';
import type {CelebrityDTO} from './types';

// Lazy load анимированных элементов
const EarnFantokensAnimatedElements = lazy(() => import('./EarnFantokensAnimatedElements'));

interface Props {
  celebrity?: CelebrityDTO;
}

const EarnFantokens: FC<Props> = memo(({celebrity}): ReactElement => {
  const t = useTranslations('EarnFantokens');
  const router = useRouter();

  const containerRef = useRef<HTMLDivElement>(null);

  return (
    <div
      ref={containerRef}
      className={`celebrity__earn-fantokens flex flex-col items-center lg:pb-0 ${
        celebrity ? 'bg-[#FF4B2E]' : 'bg-gradient-to-b from-[#FD7501] to-[#E14A10]'
      }`}
    >
      <section className="celebrity__earn-fantokens__wrapper earn_fantokens_section relative mb-8 flex w-full max-w-[1440px] flex-col items-center space-y-6 overflow-hidden lg:mb-0 lg:gap-6 lg:space-y-0 lg:pb-16 lg:pt-16 xl:gap-8">
        <Suspense fallback={null}>
          <EarnFantokensAnimatedElements containerRef={containerRef as React.RefObject<HTMLElement>} />
        </Suspense>

        <h2
          className={`relative flex flex-col text-center font-bold uppercase leading-none ${
            !celebrity ? 'mb-0 font-secondary' : 'celebrity__earn-fantokens__title font-h1 font-secondary'
          }`}
        >
          <span
            className={
              !celebrity ? 'text-[32px] leading-md tracking-tight text-white lg:text-[90px] lg:leading-[1.1]' : ''
            }
          >
            {t('Title.Top')}
          </span>
        </h2>

        <AppImage src="/images/content/StartEarningPhoneImage.png" />

        <Button
          variant="whiteSecondary"
          size="48_56"
          className="md:min-w-[350px] min-w-[288px] lg:!mt-[21px]"
          onClick={() => router.push('/earn')}
        >
          <span className="whitespace-normal">{t('Button.BecomeActive')}</span>
        </Button>
      </section>
    </div>
  );
});

export default EarnFantokens;
